const onePercent = 0.01;
const vh = window.innerHeight * onePercent;

// set height for the mobiles including top and bottom bars
export const setMobileHeight = () => {
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};
